module.exports = __webpack_public_path__ + "static/img/fm11.8b122c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm11.jpg
// module id = 5EA7
// module chunks = 1